import $ from 'jquery';
import InlineVideo from '../../components/inline-video';
import ResponsiveVideo from '../../components/responsive-video';
import RevealWhenVisible from '../../components/reveal-when-visible';
import TextSlider from './blocks/text-slider';
$(() => {
    TextSlider.init();
    RevealWhenVisible.init();
    InlineVideo.init();
    ResponsiveVideo.init();
});
